import { render, staticRenderFns } from "./indonesian_leadership_classD.vue?vue&type=template&id=46ea9fbb&scoped=true"
import script from "./indonesian_leadership_classD.vue?vue&type=script&lang=js"
export * from "./indonesian_leadership_classD.vue?vue&type=script&lang=js"
import style0 from "./indonesian_leadership_classD.vue?vue&type=style&index=0&id=46ea9fbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea9fbb",
  null
  
)

export default component.exports